import { render, staticRenderFns } from "./BuildingMaterials.vue?vue&type=template&id=04fb5a24&scoped=true&"
import script from "./BuildingMaterials.vue?vue&type=script&lang=js&"
export * from "./BuildingMaterials.vue?vue&type=script&lang=js&"
import style0 from "./BuildingMaterials.vue?vue&type=style&index=0&id=04fb5a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb5a24",
  null
  
)

export default component.exports